import { Outlet, ScrollRestoration } from 'react-router-dom';
import type { JSX } from 'react';

import { SentryWrapper } from '../../components/SentryWrapper';

import { AppBar } from '../components/AppBar';
import { MainContent } from '../components/MainContent';

type Props = Record<string, never>;

export const LoggedOutLayout = (_props: Readonly<Props>): JSX.Element => (
  <SentryWrapper>
    <ScrollRestoration />
    <AppBar variant="loggedOff" />
    <MainContent
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
      variant="loggedOff"
    >
      <Outlet />
    </MainContent>
  </SentryWrapper>
);
